import Header from "../../components/dashboard/header"
import { TbFileSettings} from 'react-icons/tb';
import { AiOutlineSetting } from "react-icons/ai";
import {Breadcrumb,Popconfirm,message, Modal,Space,Button, Input,Form, Spin} from 'antd'
import { PlusSquareOutlined,DashboardOutlined,DeleteOutlined,EditOutlined } from "@ant-design/icons";
import UploadButton from "../../components/common/uploadButton";
import {Link} from "react-router-dom";
import {useState,useEffect, useContext, useRef} from 'react';
import { extractValueFromInputRef, scrollToTop } from "../../helpers/dom";
import DataTable from "../../components/common/table";
import RefreshContext from "../../context/refreshContext";
import { useCreatePVType, useDeletePVType, usePVTypes, useUpdatePVType } from "../../hooks/voucherTypes/voucherTypeQuery";



const voucherListColumns = [
    {
        title:'S/N',
        dataIndex:'id',
        key:'id',
        render:(_,__,idx)=>idx+1
    },
    {
        title:"Title",
        dataIndex:"title",
        key:"title"
    },
    {
        title:'value',
        dataIndex:'value',
        key:'value'
    },
    {
        title:'Action',
        key:'action',
        render:(_,item)=>(
            <VoucherEdit voucher={item}/>
        )
    }
]


function VoucherEdit({voucher}){
    const [isEditOpen,setIsEditOpen] = useState(false);
    const handleOpen = ()=> setIsEditOpen(true);
    const handleClose = ()=> setIsEditOpen(false);

    const updatePVType = useUpdatePVType();
    const deletePVType = useDeletePVType();

    const titleRef = useRef(null);
    const valueRef = useRef(null);

    const {flag,setFlag} = useContext(RefreshContext);

    const confirmDeletePVType = async ()=>{
        const {message:response} = await deletePVType(voucher.id);

        message.success(response??"Salary Structure deleted successfully");
        setFlag(!flag);
    }



    const handleSubmit = async ()=>{
        const payload = {
            title:extractValueFromInputRef(titleRef),
            value:extractValueFromInputRef(valueRef)
        }
        const {message:response} = await updatePVType(voucher.id,payload);
        message.success(response??"Salary Structure updated successfullty");
        setFlag(!flag);
        setIsEditOpen(false);
    }

    // const confirmDelete = ()=>message.success('Salary Structure deleted successfully');

    return(
        <>
            <Space size="small" wrap>
                <Button type="primary" onClick={handleOpen}>
                <EditOutlined />
                    Edit
                </Button>
                <Popconfirm
                     title="Delete this Item"
                     description="Are you sure to delete this?"
                     onConfirm={confirmDeletePVType}
                    onCancel={()=>null}
                    okText="Yes"
                    cancelText="No"
                     >
                    <Button type="primary" danger>
                        <DeleteOutlined />
                        Delete
                    </Button>
                </Popconfirm>
            </Space>
            <Modal open={isEditOpen} title={'Update Salary Structure'} footer={null} onCancel={handleClose}>
                <Form initialValues={{...voucher}}>
                <Form.Item name='title'>
                        <Input ref={titleRef} type="text" placeholder="Enter Salary Structure Title"/>
                    </Form.Item>
                    <Form.Item name='value'>
                        <Input type="text" ref={valueRef} placeholder="Enter Salary Structure Value"/>
                    </Form.Item>
                    <Form.Item
                               wrapperCol={{
                                span:8,
                                offset:20
                              }}
                              className="submit-button-wrapper"
                            >
                              <Button style={{backgroundColor:"green"}} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                                Update
                              </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}


export default function VoucherConfig(){
    const [isOpen,setIsOpen] = useState(false);
    const showCreateModal = ()=> setIsOpen(true);
    const hideCreateModal =()=>setIsOpen(false);

    const titleRef = useRef(null);
    const valueRef = useRef(null);

    const {flag,setFlag} = useContext(RefreshContext);


    const {loading,structures} = usePVTypes(flag);
    const createPVType = useCreatePVType();

    const handleSubmit = async ()=>{
        const payload = {
            title : extractValueFromInputRef(titleRef),
            value:extractValueFromInputRef(valueRef)
        }
        const {message:response} = await createPVType(payload);
        message.success(response??"Salary Structure added successfully");
        setFlag(!flag);
        setIsOpen(false);
    }


    useEffect(()=>{
        scrollToTop();
    },[]);


    return(
        <>
             <div className="main-container">
                <Header/>
                <div className="main-body">

                    <div className="info-bar">
                    <Breadcrumb>
                        <Breadcrumb.Item>
                        <DashboardOutlined className="dashboard-icon"/>
                        <Link to={"/dashboard"}>Dashboard</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                        <AiOutlineSetting/>
                        <Link to={"/dashboard"}>Configuration</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <TbFileSettings />
                            <Link to="/dashboard/voucher-config">Salary Structure</Link>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div style={{display:'flex',gap:'1em'}}>
                            <UploadButton/>
                            <Button style={{backgroundColor:"green",color:"#FFFFFF"}} onClick={showCreateModal}>
                            <PlusSquareOutlined />
                                Add Salary Structure
                            </Button>
                        </div>
                    </div>

                    <div className="table-section">
                        <Spin spinning={loading}>
                        <DataTable cols={voucherListColumns} data={structures}/>
                        </Spin>
                    </div>
                </div>
            </div>
            <Modal open={isOpen} title={'Add Salary Structure'} footer={null} onCancel={hideCreateModal}>
                <Form>
                    <Form.Item name='title'>
                        <Input type="text" ref={titleRef} placeholder="Enter Salary Structure type"/>
                    </Form.Item>
                    <Form.Item name="value">
                        <Input type="text" ref={valueRef} placeholder="Enter Salary Structure value"/>
                    </Form.Item>
                    <Form.Item
                               wrapperCol={{
                                span:8,
                                offset:20
                              }}
                              className="submit-button-wrapper"
                            >
                              <Button style={{backgroundColor:"green"}} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                                Create
                              </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}
